/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.20/esri/copyright.txt for details.
*/
const a="20210630",e="fe2e87fa7f7237c8934373022cb4ed90ab5a9a74";export{a as buildDate,e as commitHash};
